export default function ArrowInActive() {
    return (
        <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.40625 7.59961L0.0761216 0.0996102L8.73638 0.0996094L4.40625 7.59961Z" fill="#CBCBE8" />
        </svg>
    )
}